import Vue from 'vue';
import store from './../../store';

const success = (id, resolve) => {
  store.dispatch('removeCreditNoteProduct', id);
  resolve();
};

const failed = reject => reject();

export default (creditNoteId, creditNoteProductId) => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/credit_notes/${creditNoteId}/products/${creditNoteProductId}`)
    .then(() => {
      success(creditNoteProductId, resolve);
    })
    .catch(() => {
      failed(reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/creditNoteProduct/destroy.js